import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 10000 }
  }

  connect() {
    this.pause = this.pause.bind(this)
    this.resume = this.resume.bind(this)

    this.element.addEventListener("mouseenter", this.pause)
    this.element.addEventListener("mouseleave", this.resume)
    this.element.addEventListener("focusin", this.pause)
    this.element.addEventListener("focusout", this.resume)

    this.resume()
  }

  disconnect() {
    this.pause()

    this.element.removeEventListener("mouseenter", this.pause)
    this.element.removeEventListener("mouseleave", this.resume)
    this.element.removeEventListener("focusin", this.pause)
    this.element.removeEventListener("focusout", this.resume)
  }

  close() {
    this.element.remove()
  }

  pause() {
    clearTimeout(this.timeout)
  }

  resume(event) {
    const focused = event?.type === "focusout"
      ? this.element.contains(event.relatedTarget)
      : this.element.contains(document.activeElement)
    if (focused || this.element.matches(":hover")) return

    this.pause()
    this.timeout = setTimeout(() => this.close(), this.delayValue)
  }
}
